import { render, staticRenderFns } from "./WtBadge.vue?vue&type=template&id=a546bd0a&scoped=true&lang=pug&"
import script from "./WtBadge.vue?vue&type=script&lang=js&"
export * from "./WtBadge.vue?vue&type=script&lang=js&"
import style0 from "./WtBadge.vue?vue&type=style&index=0&id=a546bd0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a546bd0a",
  null
  
)

export default component.exports